






import { createComponent } from '@vue/composition-api';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import WebPanel from '@sbvr/lbe-web-panel/WebPanel.vue';

export default createComponent({
  name: 'App',
  components: {
    UIButton,
    WebPanel,
  },
  setup() {},
});
